import api from '@/api-v2/partySign'
import { get, reduce, uniq, filter } from 'lodash-es'
// import formConfig from '@/config/sign/config'
// import * as metaData from '@/config/sign/metaData'
import { requestHelper, requestSilence } from '@/common/utils/request'
import { i18n } from '@/common/utils/i18n'

import partyFormConfig from '@/config-v2/party/sign/config'
import * as partyMetaData from '@/config-v2/party/sign/metaData'

export default {
/**
 * 根据shopId获取关联的主体信息
 */
async getContractorByShopId ({ commit, state }, data) {
  const res = await api.getSignInfoByShopId(data)
  if(res){
    commit('setRelatedParty', { data: res.data, path: 'relatedParty' })
  }
},
/**
 * 根据shopId创建新主体
 */
async createContractorByShopId ({ commit, state }, data) {
  const res = await api.createContractorByShopId(data)
  if(res){
    commit('setRelatedParty', { data: res.data.contractorId, path: 'relatedParty.contractorId' })
  }
},
/**
 * 选择签约方式
 */
async setContractSignType ({ commit, state }, data) {
  const res = await api.setContractSignType(data)
  if(res){
    commit('setRelatedParty', { data: data.signType, path: 'relatedParty.orderType' })
    return res
  }
  return false
},

/**
 * 更新主体信息
 */
  async updateSignInfo ({ dispatch, state}, { data, contractorId}) {
    const res = await requestHelper(api.saveSignDetail, data)
    if (res) {
      dispatch('goto', { name: 'partySign', params: { type: '0', id: contractorId }, method: 'replace' }, { root: true })
    }
  },
/**
 * 获取主体详细信息
 */
async getSignDetail ({ commit, dispatch }, payload) {
  const { queryId } = payload
  const res = await requestHelper(api.getSignDetail, payload)
  if (res) {
    // 数据格式转换
    await dispatch('revertBackendData', { res: res, queryId})
    // 签约方式
    commit('pickSignType', get(res, 'contractGlobal.signType'))
    commit('setAuditInfo', get(res, 'auditGlobal', {}))
  }
},

/**
 * 后端表单数据转换为视图数据
 */
async revertBackendData ({ commit, state }, payload) {
  // 从partyFormConfig与partyMetaData获取到实际的格式转换函数revert并进行格式转换
    const revertor = partyFormConfig.reduce((red, { group }) => {
      let pairs = {}
      if (group) {
        group.forEach(({ name }) => (pairs[name] = get(partyMetaData, [name, 'revert'])))
      }
      return { ...red, ...pairs }
    }, {})
    // 对于关联门店这一项，暂时不做格式处理
    revertor.relationShop =function revert(){}
    const signForm = reduce(
      revertor,
      (red, revert, key) => {
        return { ...red, [key]: revert(payload.res) }
      },
      {}
    )
    signForm.relationShop = await requestHelper(api.getSignRelationShopList, {contractorId: payload.queryId})
    commit('setSignInfo', { path: 'signForm', data: signForm })
},
/**
 * 检验是否必填
 */
async checkCompeleteStatus ({ commit, dispatch, state }, payload) {
  const {meta, namePath} = payload
  // status用于判断页面显示“已添加/未添加”,completeStatus用于判断是否已完成,页面显示未添加，但是必填信息都填完了，完成状态应该也为true
  let status = false
  let completeStatus  = false
  if(namePath==='relationShop'){
    const relationShopList = state.signForm.relationShop || []
    commit('setRequired', { path: ['needRequired', namePath].join('.'), data: true })
    status = !!relationShopList.length && relationShopList.every(item => item.completeStatus)
    completeStatus = status
  }else{
    // 筛选出必填项和非必填项
    const requiredField = filter(meta, ({ rules, checkVisible }) =>
      rules ? rules.some(rule => rule[0] === 'required' || rule === 'required') : false
    )
    commit('setRequired', { path: ['needRequired', namePath].join('.'), data: !!requiredField.length })
    const notRequiredField = filter(meta, ({ rules }) =>
      rules ? rules.every(rule => rule[0] !== 'required' && rule !== 'required') : true
    )
    const data = get(state, ['signForm', namePath].join('.'), {})
    // 没有required字段，按照非必填表单校验规则校验, 任意填了一项就认为已填
    if (!requiredField.length) {
      completeStatus = true
      status = notRequiredField.some(({ prop, checkVisible }) => {
        let ret = true
        if (checkVisible) {
          ret = checkVisible(data)
        }
        return ret ? (Array.isArray(data[prop]) ? data[prop].length : data[prop] != null && data[prop] !== '') : false
      })
    }else{
      // 有required字段，必填项有一个为 空/空字符串 认为未完成
      status = requiredField.every(({ prop, checkVisible }) => {
        let ret = true
        if (checkVisible) {
          ret = checkVisible(data)
        }
        return ret ? (Array.isArray(data[prop]) ? data[prop].length : data[prop] != null && data[prop] !== '') : true
      })
      completeStatus = status
    }
  }
  commit('setCheckStatus', { path: ['checkStatus', namePath].join('.'), data: status })
  commit('setCompleteStatus', { path: ['completeStatus', namePath].join('.'), data: completeStatus })
},
/**
 * 获取主体关联的门店信息
 */
async  getSignRelationShopList ({ commit, state }, payload) {
  const data = await requestHelper(api.getSignRelationShopList, payload)
  if(data){
    commit('updateSignRelationShopList', data)
  }
},
/**
 * 提交至审批
 */
  async submitSignDetail ({ commit, dispatch, state }, { contractorId }) {
    try {
      const res = await requestHelper(api.submitSignDetail, { contractorId })
      if (res) {
        dispatch('message', i18n.gettext('提交成功！'), { root: true })
        commit('updateAuditStatus', 2)
      }
    } catch (error) {
      console.error(error)
      return false
    }
  },
  async getCommonConfig ({ commit, dispatch }, payload) {
    const res = await requestSilence(api.getCommonConfig, payload)
    commit('updateTaxSourceTypeConfig', {
      taxSourceType: res || []
    })
    return res
  }
}
